<template>
        <div class="table__responsive">
            <table class="table table__responsive">
                <thead v-if="!loadingInvoices && invoices.length">
                    <tr>
                        <th>{{$t('dashboard.invoices.table.header.invoice_number')}}</th>
                        <th>{{$t('dashboard.invoices.table.header.total')}}</th>
                        <th>{{$t('dashboard.invoices.table.header.vat')}}</th>
                        <th>{{$t('dashboard.invoices.table.header.incl_vat')}}</th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-if="loadingInvoices" :key="'loading'" class="table--loading">
                        <td colspan="7">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('dashboard.invoices.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingInvoices && !invoices.length" :key="'no-invoices'" class="table--empty">
                        <td colspan="7">
                            <div class="text-center">{{$t('dashboard.invoices.table.no_invoices')}}</div>
                        </td>
                    </tr>
                    <tr v-if="invoices.length" v-for="invoice in invoices" :key="invoice.id">
                        <td>{{ invoice.invoice_number }}</td>
                        <td>{{ invoice.total | toCurrency }}</td>
                        <td>{{ invoice.vat | toCurrency }}</td>
                        <td>{{ invoice.total_with_vat | toCurrency }}</td>
                        <td><span @click="editInvoice(invoice)" v-tooltip.bottom="$t('dashboard.invoices.table.edit')" class="table__icon icons icon-pencil"></span></td>
                        <td><span @click="downloadInvoice(invoice)" v-tooltip.bottom="$t('dashboard.invoices.table.download')" class="table__icon icons icon-cloud-download"></span></td>
                        <td><span @click="showDeleteInvoiceModal(invoice)" v-tooltip.bottom="$t('dashboard.invoices.table.delete')" class="table__icon icons icon-trash"></span></td>
                    </tr>
                    <tr v-if="invoicesMeta && invoicesMeta.last_page > 1" class="table__navigation">
                        <td colspan="7">
                            <pagination :meta="invoicesMeta" @goToPage="goToPage"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { saveFile } from '@/helpers';
    import Pagination from '@/components/tables/Pagination';
    import { GET_INVOICES } from '@/store/modules/invoices';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class InvoicesTable extends Vue {
        name = 'invoices-table';

        created() {
            this.$store.dispatch(GET_INVOICES, {});
        }

        get invoices() {
            return this.$store.state.invoices.invoices;
        }

        get loadingInvoices() {
            return this.$store.state.invoices.loading;
        }

        get invoicesMeta() {
            return this.$store.state.invoices.invoicesMeta;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_INVOICES, { params: { page: pageNo }});
        }

        editInvoice(invoice) {
            this.$router.push({ name: 'edit-invoice', params: { trajectoryId: this.$store.state.trajectory.trajectory.id, invoiceId: invoice.id }});
        }

        downloadInvoice(invoice) {
            let URL = `trajectories/${this.$store.state.trajectory.trajectory.id}/invoices/${invoice.id}/download`;
            let fileNameParams = {
                number: invoice.invoice_number,
                reference: invoice.declaration_reference,
                date: this.$options.filters.formatDate(invoice.invoice_date),
            };
            let fileName = this.$t('dashboard.invoices.file_name', fileNameParams);
            fileName += '.pdf';
            return this.axios.get(URL, {responseType: 'blob'})
                .then(
                    res => saveFile(res.data, fileName, 'application/pdf'),
                    err => this.$notify.error(this.$t('notify.download_errror')));
        }

        showDeleteInvoiceModal(invoice) {
            const content = {
                title: this.$t('modals.delete_invoice.title'),
                message: this.$t('modals.delete_invoice.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteInvoice, invoice});
        }

        deleteInvoice({invoice}) {
            invoice.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.invoice.delete_success'));
                    this.$store.dispatch(GET_INVOICES, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.invoice.delete_error')));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/InvoicesTable.vue